import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Youtube, Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <div className="footer-container">
        <div className="footer-logo-section">
          <img 
            src="https://customer-assets.emergentagent.com/job_spec-evaluator/artifacts/8a4vgz8k_litvill_logo_alpha.png" 
            alt="Litvill Logo" 
            className="footer-logo"
          />
          <p className="footer-tagline">Learn. Live. Lead.</p>
        </div>

        <div className="footer-links">
          <Link to="/" className="footer-link" data-testid="footer-home">Home</Link>
          <Link to="/english" className="footer-link" data-testid="footer-english">English</Link>
          <Link to="/programs" className="footer-link" data-testid="footer-programs">Programs</Link>
          <Link to="/movement" className="footer-link" data-testid="footer-movement">Movement</Link>
          <Link to="/about" className="footer-link" data-testid="footer-about">About</Link>
          <Link to="/contact" className="footer-link" data-testid="footer-contact">Contact</Link>
        </div>

        <div className="footer-social">
          <h3 className="follow-us-title">Follow Us:</h3>
          <a 
            href="https://www.linkedin.com/company/litvill-lessons-association/?viewAsMember=true" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="social-link"
            data-testid="footer-linkedin"
            aria-label="LinkedIn"
          >
            <Linkedin size={24} />
            <span>Follow what's happening now</span>
          </a>
          <a 
            href="https://www.youtube.com/channel/UCDQfgugsKhJDCohUDj7lquA/videos" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="social-link"
            data-testid="footer-youtube"
            aria-label="YouTube"
          >
            <Youtube size={24} />
            <span>Explore our videos</span>
          </a>
          <a 
            href="mailto:info@litvill.com" 
            className="social-link"
            data-testid="footer-email"
            aria-label="Email"
          >
            <Mail size={24} />
            <span>info@litvill.com</span>
          </a>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Litvill. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;